import { useState } from 'react';
import { faqList } from '../../../mocks/news';

export default function Faq() {
  const [open, setOpen] = useState<number>(0);
  return (
    <section id="faq" className="scroll-mt-24 py-12 md:py-16 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12">
        <div className="lg:col-span-4">
          <span className="text-xs font-semibold text-primary-600 tracking-widest uppercase">HELP CENTER</span>
          <h2 className="mt-1 font-heading text-2xl md:text-4xl font-black text-foreground-950">常见问题</h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            关于内容可信度、投稿方式与平台立场，你关心的问题大多能在这里找到答案。还有疑问，欢迎直接联系我们。
          </p>
          <div className="mt-6 rounded-xl bg-accent-100/80 border border-accent-200 p-5">
            <div className="flex items-center gap-2 text-accent-900 font-semibold text-sm">
              <i className="ri-customer-service-2-line text-lg" aria-hidden="true" /> 找不到答案？
            </div>
            <p className="mt-2 text-xs text-accent-800 leading-relaxed">
              通过页面底部邮箱或「投稿爆料」与我们取得联系，编辑部会尽快回复你的留言。
            </p>
          </div>
        </div>

        <div className="lg:col-span-8 flex flex-col gap-3">
          {faqList.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`rounded-xl border transition ${
                  isOpen ? 'border-primary-300 bg-background-100' : 'border-background-200 bg-background-100/60 hover:border-background-300'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className={`font-heading text-sm md:text-base font-bold leading-snug ${isOpen ? 'text-primary-700' : 'text-foreground-950'}`}>
                    {f.q}
                  </span>
                  <span className={`shrink-0 flex w-7 h-7 items-center justify-center rounded-full transition ${isOpen ? 'bg-primary-500 text-background-50 rotate-180' : 'bg-background-200 text-foreground-600'}`}>
                    <i className="ri-arrow-down-s-line text-lg" aria-hidden="true" />
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm text-foreground-700 leading-relaxed border-t border-background-200 pt-4">{f.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}